const DefaultResizeBehavior = require('../animations/behaviors/PreloaderDefaultResizeBehavior');

const body = document.body;
const preloadBlock = document.querySelector('.preloader');
const preloadState = {value: 0};
body.dataset.loading = true;

const resizeBehavior = DefaultResizeBehavior(document.querySelector('.preloader__girl-block'));
const resizePreload = () => {
    resizeBehavior.resize();
    setTimeout(() => {
        preloadBlock.classList.add('preloaded');
    }, 300);
};
resizePreload();
window.addEventListener('resize', resizePreload);

const __setProgress = p => {
    if (p > preloadState.value) preloadState.value = p;
};

module.exports.destroy = t => {
    delete body.dataset.loading;
    body.dataset.loaded = 'true';

    setTimeout(() => {
        window.removeEventListener('resize', resizePreload);
        if (preloadBlock.parentNode) preloadBlock.parentNode.removeChild(preloadBlock);
    }, (t || 0.7) * 1000);
};

module.exports.update = function(loader) {
    body.dataset.loading = true;

    __setProgress(Math.floor(loader.progress));
};
